// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import data from '../.freec/static/categories.json'
export default data
